import { render, staticRenderFns } from "./BillPrintWarrantyBenefitPolicyModal.vue?vue&type=template&id=3972df20&scoped=true"
import script from "./BillPrintWarrantyBenefitPolicyModal.vue?vue&type=script&lang=js"
export * from "./BillPrintWarrantyBenefitPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./BillPrintWarrantyBenefitPolicyModal.vue?vue&type=style&index=0&id=3972df20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972df20",
  null
  
)

export default component.exports